import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  LoadingController,
  NavController,
  NavParams,
  ToastController,
  ViewController
} from "ionic-angular";
import { AppDetectorProvider } from "../../../../providers/detector/detector";
import {
  EventDefineModel,
  EventDetailsModel
} from "../../../../providers/event/event";
import {
  SinleValueModel,
  ValueProvider
} from "../../../../providers/value/value";

/**
 * Generated class for the EventCreateRacePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: "page-event-create-race",
  templateUrl: "event-create-race.html"
})
export class EventCreateRacePage {
  grading: SinleValueModel[] = [];
  vintagesFrom: SinleValueModel[] = [];
  vintagesTo: SinleValueModel[] = [];
  gradingContainer: {
    grading: string;
    vintageFrom: string;
    vintageTo: string;
  } = { grading: "", vintageFrom: "", vintageTo: "" };
  eventDefine: EventDefineModel;
  event: EventDetailsModel;
  isCreate: boolean;
  eventDefineBackup: EventDefineModel;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public translate: TranslateService,
    private valueService: ValueProvider,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    private detector: AppDetectorProvider
  ) {
    this.event = this.navParams.data.data.event;
    this.eventDefine = this.navParams.data.data.define;
    this.isCreate = this.navParams.data.data.isCreate;
    if (!this.isCreate) {
      this.eventDefineBackup = this.eventDefine;
      this.eventDefine = JSON.parse(JSON.stringify(this.eventDefineBackup));
    }

    valueService.getEventGrading().then(grad => {
      this.grading = grad;
      this.gradingContainer.grading = grad[0].value;
    });
  }

  gradeChange(event: string) {
    this.valueService.getEventVintagesFrom(event).then(from => {
      this.vintagesFrom = from;
      this.gradingContainer.vintageFrom = from[0].value;
    });
    this.valueService.getEventVintagesTo(event).then(to => {
      this.vintagesTo = to;
      this.gradingContainer.vintageTo = to[0].value;
    });
  }

  eventStartChange(event: { hour: number; minute: number }) {
    this.eventDefine.time = event.hour + ":" + event.minute;
  }

  save() {
    if (this.eventDefine.time.length === 0) {
      this.toastCtrl
        .create({
          duration: 3000,
          message: this.translate.instant("GLOBAL_ERROR_X_IS_REQUIRED", {
            name: this.translate.instant("EVENT_EVENT_START")
          }),
          showCloseButton: true
        })
        .present();
    } else if (
      this.eventDefine.route1 > 0 &&
      (this.eventDefine.route2 === null || this.eventDefine.route2 > 0) &&
      (this.eventDefine.route3 === null || this.eventDefine.route3 > 0)
    ) {
      let loading = this.loadingCtrl.create({
        content: this.translate.instant("GLOBAL_LOADING")
      });
      loading.present();
      this.valueService
        .getEventGradingTextCheck(
          this.gradingContainer.grading,
          this.gradingContainer.vintageFrom,
          this.gradingContainer.vintageTo
        )
        .then(
          text => {
            this.eventDefine.genderFromTo = text.value;

            if (
              !this.isCreate ||
              this.event.wertungList.find(
                x =>
                  x.genderFromTo === this.eventDefine.genderFromTo &&
                  x.price === this.eventDefine.price &&
                  x.time === this.eventDefine.time &&
                  x.route1 === this.eventDefine.route1 &&
                  x.route2 === this.eventDefine.route2 &&
                  x.route3 === this.eventDefine.route3
              )
            ) {
              this.toastCtrl
                .create({
                  duration: 3000,
                  message: this.translate.instant(
                    "EVENT_CREATE_ERROR_DUPLICATED_EVENT"
                  ),
                  showCloseButton: true
                })
                .present();
            } else {
              this.eventDefine.price = this.eventDefine.price || 0;
              if (this.isCreate) {
                this.event.wertungList.push(
                  JSON.parse(JSON.stringify(this.eventDefine))
                );
              } else {
                this.eventDefineBackup.genderFromTo = this.eventDefine.genderFromTo;
                this.eventDefineBackup.price = this.eventDefine.price;
                this.eventDefineBackup.route1 = this.eventDefine.route1;
                this.eventDefineBackup.route2 = this.eventDefine.route2;
                this.eventDefineBackup.route3 = this.eventDefine.route3;
                this.eventDefineBackup.time = this.eventDefine.time;
              }
            }

            loading.dismiss();

            // Back event
            // this.navCtrl.pop();
            this.viewCtrl.dismiss();
          },
          error => {
            loading.dismiss();
            this.toastCtrl
              .create({
                duration: 3000,
                message: error.value,
                showCloseButton: true
              })
              .present();
          }
        );
    } else {
      this.toastCtrl
        .create({
          duration: 3000,
          message: this.translate.instant("GLOBAL_ERROR_X_IS_INVALID", {
            name: this.translate.instant("EVENT_DISTANCE")
          }),
          showCloseButton: true
        })
        .present();
    }
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad EventCreateRacePage");
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// /src/pages/event/create/event-create-race/event-create-race.ts